import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "field-label is-normal" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "field-body" }
const _hoisted_4 = { class: "label" }

export type VFieldProps = {
  label?: string
  addons?: boolean
  textaddon?: boolean
  grouped?: boolean
  multiline?: boolean
  horizontal?: boolean
}
const name='VField'

export default /*@__PURE__*/_defineComponent({
  __name: 'VField',
  props: {
    label: { default: undefined },
    addons: { type: Boolean },
    textaddon: { type: Boolean },
    grouped: { type: Boolean },
    multiline: { type: Boolean },
    horizontal: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field", [
      props.addons && 'has-addons',
      props.textaddon && 'has-textarea-addon',
      props.grouped && 'is-grouped',
      props.grouped && props.multiline && 'is-grouped-multiline',
      props.horizontal && 'is-horizontal',
    ]])
  }, [
    (typeof props.label === 'string' && props.horizontal)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(props.label), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64))
      : (typeof props.label === 'string')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(props.label), 1),
            _renderSlot(_ctx.$slots, "default")
          ], 64))
        : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ], 2))
}
}

})